var map = {
	"./de.json": 95894,
	"./en.json": 44174,
	"./fr.json": 94605,
	"./ka.json": 19173,
	"./kr.json": 87416,
	"./oz.json": 31212,
	"./ru.json": 74600,
	"./tr.json": 79755,
	"./uz.json": 17906,
	"./zh.json": 79527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;